import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../../utils/stateHandlers/contexts";
import { Link as DomLink } from "react-router-dom";
import api from "../../utils/api";
import { ReactMarkdown } from "react-markdown/lib/react-markdown";
import remarkGfm from "remark-gfm";
import Container from "@mui/material/Container";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import Divider from "@mui/material/Divider";
import toast from "react-hot-toast";
import _ from "lodash";

export default function Login(props) {
  const { user } = useContext(AppContext);
  const [text, setText] = useState();
  const [title, setTitle] = useState();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  function login() {
    const credentials = {
      username: email,
      password: password,
    };
    api.post("account/login", credentials).then((response) => {
      if (response.isAxiosError) {
        _.forEach(response.response.data, function (error) {
          toast.error(<Typography>{error}</Typography>);
        });
      } else {
        user.signIn(response.data, response.data.token);
      }
    });
  }

  useEffect(() => {
    api.fetchStrapi("/log-in?populate=*").then((response) => {
      setText(response.data.data.attributes.text);
      setTitle(response.data.data.attributes.title);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container maxWidth="sm">
      <Card>
        <CardHeader
          title={<Typography variant="articleTitle">{title}</Typography>}
        />
        <CardContent>
          <Stack spacing={3}>
            <Typography variant="articleText" sx={{ marginBottom: "1rem" }}>
              <ReactMarkdown children={text} remarkPlugins={[remarkGfm]} />
            </Typography>
            <Divider />
            <TextField
              required
              color="primary"
              type="email"
              onChange={(e) => setEmail(e.target.value)}
              label={<Typography variant="navText">Email</Typography>}
            />
            <TextField
              required
              color="primary"
              type="password"
              onChange={(e) => setPassword(e.target.value)}
              label={<Typography variant="navText">Password</Typography>}
            />
            <Stack spacing={1}>
              <Typography variant="subtitle2">
                <DomLink to={{ pathname: "/forgot-password" }}>
                  Forgot Password?
                </DomLink>
              </Typography>
              <Typography variant="subtitle2">
                <DomLink to={{ pathname: "/create-account" }}>
                  Don't have an account? Click here to sign up!
                </DomLink>
              </Typography>
            </Stack>
          </Stack>
        </CardContent>
        <CardActions>
          <Button
            size="small"
            color="primary"
            variant="contained"
            onClick={() => login()}
          >
            Log in
          </Button>
        </CardActions>
      </Card>
    </Container>
  );
}
